module.exports = __webpack_public_path__ + "static/front-training-68dacdfd09d00f5668911496886324e4.jpg";